var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"memberName"},[_vm._v("\n    "+_vm._s(_vm.before_text)+_vm._s(_vm.memberName)+_vm._s(_vm.after_text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }